import { z } from "zod";

export const BranchMediaFormSchema = z.object({
  mediaItems: z.array(
    z.object({
      mediaId: z.string().optional(),
      processedMediaId: z.string().optional(),
    })
  ),
});

export type BranchMediaFormType = z.infer<typeof BranchMediaFormSchema>;
